import { useDispatch, useSelector } from "react-redux";
import { selectTranslations } from "../../services/i18n/i18nSlice";
import { useLocation } from "react-router";
import { useEffect, useState, useRef } from "react";
import { setLoading, setNavbarHide, setNavbarHideMobile } from "../../services/global/globalSlice";
import { Link, useNavigate } from "react-router-dom";

import correct_img from '../../assets/images/questions/correct.svg'
import missing_img from '../../assets/images/questions/missing.svg'
import wrong_img from '../../assets/images/questions/wrong.svg'
import timer_img from './assets/images/timer.svg'
import score_img from './assets/images/score.svg'
import questions_img from '../../assets/images/questions.svg'
import hand_img from '../../assets/images/high-five-hand.svg'
import sad_img from '../../assets/images/sad.svg'
import structure_img from './assets/images/structure.svg'

import { TitleH1 } from "../../components/TitleH1";
import { TitleH3 } from "../../components/TitleH3";
import { Button } from "../../components/Button";
import { normalizeModules } from "./examUtils";
import ThresholdSheet from "./_ofa_components/ThresholdSheet";
import { selectAppInfo } from "../../services/utils/appInfoSlice";
import { selectUserData } from "../../features/User/userSlice";
import Scoreboard from "./_components/Scoreboard";
import { exitFullscreen } from "../../utils/deviceManagement";
import { loadCurrentNotificationDebounced } from "../../features/Notification/notificationSlice";
import { use } from "react";

export default function ExamEndScreen(){

    const [examData, setExamData] = useState(null)
    const [step, setStep] = useState(0)
    const [examId, setExamId] = useState("")

    const appInfo = useSelector(selectAppInfo)
    const userInfo = useSelector(selectUserData)

    const t = useSelector(selectTranslations)
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [showThresholdSheet, setShowThresholdSheet] = useState(false)

    const closeThresholdSheet = (_,redirect = true) =>{
        if(redirect)
            navigate('/',{replace: true})
        setShowThresholdSheet(false)
    }

    useEffect(()=>{
        dispatch(setNavbarHide(true))
        if(location.state?.exam_id)
            setExamId(location.state?.exam_id)
        if(location.state && location.state?.results){
            const {_questions} = normalizeModules(location.state?.results?.modules)
            setExamData({
                ...location.state.results,
                questions: _questions,
                papers: location?.state?.examData?.papers
            })
        } else if (location.state?.examData){
            setExamData(location.state?.examData)
        } else
            navigate('/exams', {replace:true})
        dispatch(setLoading(false))
        // eslint-disable-next-line
    },[location])

    useEffect(() => {
        dispatch(setNavbarHideMobile(true))
        dispatch(setNavbarHide(true))
        setTimeout(()=>{
            setShowThresholdSheet(true)
        },2000)
    }, [examData?.exam_id])

    useEffect(() => {
        if(examData?.proctoring_required)
            exitFullscreen()
    }, [examData?.proctoring_required])

    useEffect(() => {
        if (examData?.thresholds?.some(th => th?.threshold_type === 'add_to_group_threshold')
        && appInfo?.personalizations?.enabled_sections?.notifications) {
            dispatch(loadCurrentNotificationDebounced());
        }
    }, [examData?.thresholds])

    const totalTime = () => {
        let _total = 0
        examData?.modules?.forEach((m)=>
            _total += m.consumed_time
        )
        return _total
    }

    const formatTime = (time) => {
        return String(time).padStart(2, '0')
    }

    const checkAllOfaPassed = () => {
        if( examData?.thresholds?.find(t=>t.threshold_type === "subject_passing_score_threshold" && t.has_been_passed) &&
            (
                examData?.modules?.find(m=>m?.thresholds?.find(t=>t.threshold_type === "subject_passing_score_threshold")?.length > 0)?.length ==
                examData?.modules?.find(m=>m?.thresholds?.find(t=>t.threshold_type === "subject_passing_score_threshold" && t.has_been_passed)?.length > 0)?.length 
            )
        ) return true
        else
            return false
    }

    return (
        <section id="examPreviewScreen" className="end_screen">
            <div className="h-100">
            {
                examData?.visible_scoreboard ?
                    <div className="steps">
                        <div className={`bullet ${step === 0 ? 'active' : ''} `}></div>
                        <div className={`bullet ${step === 1 ? 'active' : ''} `}></div> 
                    </div> 
                : null
            }
            {examData && step === 0 ?
            <div className="d-flex flex-column justify-content-between h-100">
                <div style={{maxWidth:"500px", minWidth:"320px"}} className="mx-auto">
                    {
                        appInfo?.is_ofa ?
                        <>
                            {examData?.thresholds?.find(t=>t.threshold_type === "certificate_generation")?.has_been_passed ?
                                <img src={hand_img} style={{width:'45px'}} className="mx-auto d-block" alt=''/>
                                : 
                                <img src={sad_img} style={{width:'45px'}} className="mx-auto d-block" alt=''/>
                            }
                        </> :
                        <img src={hand_img} style={{width:'45px'}} className="mx-auto d-block" alt=''/>
                    }
                    <TitleH1 className="text-center">
                        {
                            appInfo?.is_ofa && examData?.thresholds?.find(t=>t.threshold_type === "certificate_generation" && t.is_showable) ?
                                <>
                                    {examData?.thresholds?.find(t=>t.threshold_type === "certificate_generation")?.has_been_passed ?
                                        t.ofa.exam.exam_passed_title : t.ofa.exam.exam_not_passed_title
                                    }
                                </> :
                            t.exam.exam_ended
                        }
                    </TitleH1>
                    <div className="border mt-4 mb-2 p-3 pt-4" style={{borderRadius:"16px", background:'#FFFDFC'}}>
                        <TitleH3  className="text-center"><img src={score_img} alt="" className="me-2"/> {t.exam.scoring}</TitleH3>
                        <div className="mt-2">
                            <div className="exam_score text-center">
                                <strong style={{color:'#181818'}}>{examData?.total_score}</strong> {t.exam.points}
                            </div>
                            <div className="d-flex justify-content-around mt-2">
                                <div className="d-flex flex-column justify-content-center align-items-center">
                                    <img style={{verticalAlign:"sub"}} src={correct_img} className="mb-1" alt="" />
                                    <strong>{examData?.correct_count}</strong> 
                                    <span>{t.exam.correct}</span>
                                </div>
                                <div className="d-flex flex-column justify-content-center align-items-center"><img style={{verticalAlign:"sub"}} src={missing_img} className="mb-1" alt="" /><strong>{examData?.missing_count}</strong><span>{t.exam.missing}</span> </div>
                                <div className="d-flex flex-column justify-content-center align-items-center"><img style={{verticalAlign:"sub"}} src={wrong_img} className="mb-1" alt="" /><strong>{examData?.wrong_count}</strong> <span>{t.exam.wrong}</span></div>
                            </div>
                        </div>
                    </div>
                    <div className="border mt-3 mb-2 p-3 pt-4" style={{borderRadius:"16px", background:'#FFFDFC'}}>
                        <TitleH3 className="text-center"><img src={timer_img} alt="" className="me-2"/>{t.exam.duration}</TitleH3>
                        <div className="mb-2  mt-3  ">
                            <div className="exam_score  text-center">
                                <strong style={{color:'#181818'}}>{totalTime()} min</strong>/ {examData.time}
                            </div>
                        </div> 
                    </div>
                    {
                        (examData?.is_self_assessment_test || appInfo?.is_ofa) &&
                        <div className="border mt-3 mb-2 p-3 pt-4" style={{borderRadius:"16px", background:'#FFFDFC'}}>
                            <TitleH3 className="text-center"><img src={structure_img} alt="" className="me-2"/>{t.exam.modules}</TitleH3>
                            {examData?.thresholds?.map((t,i)=>{
                                if(t?.threshold_type === "standard_threshold")
                                    return(
                                        <div className="mb-2" key={i}>
                                            <span>{t.threshold_name}</span>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span>{examData?.total_score} pt.</span>
                                                <span>{t?.has_been_passed ? <span className="text-success">{t.ofa?.scoring.passed}</span> : <span className="text-danger">{t.ofa?.scoring.not_passed}</span>}</span>
                                            </div>
                                            <hr />
                                        </div>
                                    )
                                else
                                    return null
                                })
                            }
                            {examData?.modules?.map((m,i)=>{
                                if(m?.thresholds?.find(t=> t?.threshold_type === "standard_threshold"))
                                    return(
                                        <div className="mb-2" key={i}>
                                            <span>{m.module_name}</span>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span>{m?.total_score} pt.</span>
                                                <span>{m?.thresholds?.find(t=> t?.threshold_type === "standard_threshold" && t?.has_been_passed) ? <span className="text-success">{t.ofa?.passed}</span> : <span className="text-danger">{t.ofa?.scoring.not_passed}</span>}</span>
                                            </div>
                                            <hr />
                                        </div>
                                    )
                                else
                                    return null
                                })
                            }
                        </div>
                    }
                </div>
                <div>
                    {
                        examData?.questions?.length > 0 ?
                            <Link to={'/exams/review/'} state={{examData: examData, examId: examId}} replace={true}>
                                <Button className="mx-auto w-100">
                                    <img src={questions_img} alt="" className="me-1"/>
                                    {t.exam.questions_review}
                                </Button>
                            </Link>
                        : null
                    }
                    {
                        examData.visible_scoreboard ?
                            <div className="d-flex justify-content-center mx-auto mt-3" style={{maxWidth:"360px"}}>
                                <Button color="secondary" disabled={true} className="me-2 w-50">
                                   {t.buttons.back}
                                </Button>
                                <Button color="secondary" className="w-50" onClick={()=>{setStep(1)}}>
                                    {t.buttons.next}
                                </Button>
                            </div>
                        :
                        <>
                            {
                                examData?.is_self_assessment_test ?
                                <Link 
                                    to={`/exams/exam_detailed_results/${examId}`} 
                                    replace={true}
                                >
                                    <Button color="primary" className="mx-auto mt-2 w-100 pointer">
                                        {t.buttons.continue}
                                    </Button>
                                </Link> : 
                                <Link 
                                    to={appInfo?.is_ofa && checkAllOfaPassed() ? '/' : '/exams/'} 
                                    replace={true}
                                >
                                    <Button color="secondary" className="mx-auto mt-2 w-100">
                                        {appInfo?.is_ofa && !checkAllOfaPassed() ? t.buttons.keep_training : t.buttons.exit}
                                    </Button>
                                </Link> 
                            }
                        </>
                            
                    }
                    
                </div>
            </div>
            : null}
            {examData && step === 1 ?
            <div className="d-flex flex-column justify-content-between h-100">
                <div style={{maxWidth:"500px", minWidth:"320px", height:"80%"}} className="mx-auto">
                    <TitleH1 className="text-center">
                        {
                            t.scoreboard.title
                        }
                    </TitleH1>
                    <div style={{height:"100%"}}>
                        <Scoreboard examId={examId}  />
                    </div>
                </div>
                <div>
                    <div>
                        <Button color="secondary" onClick={()=>{setStep(0)}} className="mx-auto mt-2 w-100">
                            {t.buttons.back}
                        </Button>
                        <Link 
                            to={ appInfo?.is_ofa && !examData?.thresholds?.find(t=>t.threshold_type === "certificate_generation")?.has_been_passed ? '/' : '/exams/'} 
                            replace={true}
                        >
                            <Button className="mx-auto mt-2 w-100">
                                {appInfo?.is_ofa && !examData?.thresholds?.find(t=>t.threshold_type === "certificate_generation")?.has_been_passed ? t.buttons.keep_training : t.buttons.exit}
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
            : null}
            </div>
        </section>
    )
}